import type { Status } from '@/entities/user/model/userSchema';
import { DOC_TYPE_LABEL } from '@/shared/constants';

export const docTypeLabel = DOC_TYPE_LABEL;

export function statusLabel(st: Status): string {
  return st === 'ok' ? 'Действует' : 'Архив';
}

export function versionDocumentStatusLabel(st: Status): string {
  if (st === 'ok') return 'Действующая';
  if (st === 'info') return 'Предыдущая';
  return 'Архив';
}

export const REGISTRY_STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Все' },
  { value: 'ok', label: 'Действует' },
  { value: 'err', label: 'Архив' },
] as const;

export const VERSION_SCOPE_FILTER_OPTIONS = [
  { value: 'local', label: 'Только локальные' },
  { value: 'all', label: 'Все типы' },
] as const;
